module.exports = __webpack_public_path__ + "93b84aa3d7205ba8ab6bd4a3f065954a.svg";